import { render } from "./PaymentToken.vue?vue&type=template&id=5e290803&lang=pug"
import script from "./PaymentToken.vue?vue&type=script&lang=js"
export * from "./PaymentToken.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__